import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import * as FiIcons from 'react-icons/fi'
import SafeIcon from '../components/ui/SafeIcon'

const { FiTrendingUp, FiUsers, FiGlobe, FiAward } = FiIcons

function SellerPage() {
  const benefits = [
    { icon: FiTrendingUp, title: 'Weltweite Reichweite', description: 'Erreichen Sie Millionen von Käufern weltweit', stats: '50M+ Käufer' },
    { icon: FiUsers, title: 'Vorgeprüfte Käufer', description: 'Zugang zu qualifizierten Business-Käufern', stats: '500K+ Businesses' },
    { icon: FiGlobe, title: 'Mehrsprachiger Support', description: 'Unterstützung in 20+ Sprachen', stats: '20+ Sprachen' },
    { icon: FiAward, title: 'Verifizierte Partner', description: 'Werden Sie ein verifizierter Lieferant', stats: 'Gold Status' }
  ]

  const membershipPlans = [
    { name: 'Basic', price: 'Kostenlos', features: ['Bis zu 50 Produkte', 'Standard-Support', 'Basic Verifizierung'], recommended: false },
    { name: 'Pro', price: '€99/Monat', features: ['Unbegrenzte Produkte', 'Priorität-Support', 'Gold Verifizierung', 'Featured Listings'], recommended: true },
    { name: 'Enterprise', price: 'Kontaktieren Sie uns', features: ['Alles aus Pro', 'Dedicated Account Manager', 'Custom Lösungen', 'API Zugang'], recommended: false }
  ]

  return (
    <>
      <Helmet>
        <title>Verkaufen auf 1688Euro.com | Werden Sie Lieferant | B2B Plattform</title>
        <meta name="description" content="Werden Sie Lieferant auf 1688Euro.com - Erreichen Sie Millionen von Business-Käufern weltweit. Verkaufen Sie direkt an europäische Unternehmen." />
        <meta name="keywords" content="Verkaufen,Lieferant werden,B2B Plattform,Hersteller China,Export,Großhandel,1688Euro.com" />
        <link rel="canonical" href="https://1688euro.com/seller" />
      </Helmet>

      <div className="min-h-screen bg-[#F2F3F7] py-8">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          {/* Hero Section */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 mb-8 text-center">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Werden Sie Lieferant auf 1688Euro.com</h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto mb-6"> Erreichen Sie Millionen von Business-Käufern weltweit und expandieren Sie Ihr Geschäft international </p>
            <Link to="/register?type=seller" className="inline-block bg-[#FF6600] text-white px-8 py-3 rounded-lg font-bold hover:bg-[#e55c00] transition-colors">
              Jetzt auf 1688Euro.com registrieren
            </Link>
          </div>

          {/* Benefits Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            {benefits.map((benefit, index) => (
              <div key={index} className="bg-white rounded-lg border border-gray-200 p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <SafeIcon icon={benefit.icon} className="w-8 h-8 text-blue-600" />
                </div>
                <h3 className="font-bold text-gray-900 mb-2">{benefit.title}</h3>
                <p className="text-sm text-gray-600 mb-2">{benefit.description}</p>
                <span className="text-sm font-bold text-[#FF6600]">{benefit.stats}</span>
              </div>
            ))}
          </div>

          {/* Membership Plans */}
          <div className="bg-white rounded-lg border border-gray-200 p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">Mitgliedschaftspläne bei 1688Euro.com</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {membershipPlans.map((plan, index) => (
                <div key={index} className={`relative border rounded-lg p-6 ${plan.recommended ? 'border-[#FF6600] shadow-lg transform scale-105' : 'border-gray-200'}`}>
                  {plan.recommended && (
                    <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                      <span className="bg-[#FF6600] text-white px-3 py-1 rounded-full text-sm font-bold"> Empfohlen </span>
                    </div>
                  )}
                  <h3 className="text-xl font-bold text-gray-900 mb-2 text-center">{plan.name}</h3>
                  <div className="text-2xl font-bold text-[#FF6600] mb-4 text-center">{plan.price}</div>
                  <ul className="space-y-2 mb-6">
                    {plan.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center text-sm text-gray-600">
                        <SafeIcon icon={FiAward} className="w-4 h-4 text-green-500 mr-2" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                  <Link
                    to="/register"
                    className={`w-full block text-center py-2 rounded-lg font-bold transition-colors ${plan.recommended ? 'bg-[#FF6600] text-white hover:bg-[#e55c00]' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
                  >
                    {plan.price === 'Kontaktieren Sie uns' ? 'Kontakt aufnehmen' : 'Jetzt auf 1688Euro.com starten'}
                  </Link>
                </div>
              ))}
            </div>
          </div>

          {/* Success Stories */}
          <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-lg p-8 text-white text-center">
            <h2 className="text-2xl font-bold mb-4">Erfolgsgeschichten auf 1688Euro.com</h2>
            <p className="mb-6 opacity-90"> "Durch 1688Euro.com haben wir unser Exportgeschäft um 300% gesteigert und neue Märkte in Europa erschlossen." </p>
            <div className="text-sm opacity-80">- Zhang Wei, CEO TechPro Manufacturing</div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SellerPage